import { EAttributeType, ECategoryType } from '@src/emp-3.0/types';

export function isEventAttributeType(attribute_type?: number) {
  return attribute_type === EAttributeType.Event;
}

export function isGlobalAttributeType(attribute_type?: number) {
  return attribute_type === EAttributeType.Global;
}

export function isNetworkCategory(category?: string) {
  return category === ECategoryType.NETWORK;
}
